import { ReactNode } from 'react';

import { Link } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';

import {
  createResourceLinkExtension,
  extractLastNameComponent,
  isResourceName,
} from '@spotify/confidence-core-react';

import { flagsPlugin } from '../plugin';
import { flagRouteRef } from '../routes';

interface FlagResourceLinkProps {
  name: string;
  text: ReactNode;
  className?: string;
}

const FlagResourceLink = ({ name, text, className }: FlagResourceLinkProps) => {
  const routeRef = useRouteRef(flagRouteRef);
  const flagId = extractLastNameComponent(name);

  if (!routeRef || !flagId) {
    return <>{text}</>;
  }

  const to = routeRef({ id: flagId });

  return (
    <Link to={to} className={className}>
      {text}
    </Link>
  );
};

export const FlagResourceLinkExtension = flagsPlugin.provide(
  createResourceLinkExtension({
    id: 'flag-resource-link',
    predicate: ({ name }) => isResourceName(name, 'flags'),
    icon: 'flag',
    render: ({ name, text, className }) => (
      <FlagResourceLink name={name} text={text} className={className} />
    ),
  }),
);
